/*
 * email.js - McMahon
 * Copyright 6/27/18, Dan Griffin at TG
 * www.wearetg.com
 */

/* Table of Content
==================================================
	# Email Decoding
*/

/* # Email Decoding
================================================== */
(function($) { 
	$("a.ga-email.js-o").each(function() {
		$(this).text(atob($(this).text()));
		$(this).attr("href", atob($(this).attr("href")));
	});
})(jQuery);